import { O365MailWebView } from '../view/O365MailWebView';
import { templateO365Mail } from '../view/template';
import { O365MailWebComponent } from '../component/O365MailWebComponent';
import { O365SensorController } from '../../base/o365/controller/O365SensorController';
import { IListenerConfig } from '../../../../framework/BaseWebComponentController';
import { WEB_COMPONENT_SENSOR_O365_AUDIT } from '../../../../webcomponents.constants';
import { O365MailFields, O365AuditFields } from '../../constants';

export class O365MailWebController extends O365SensorController {
  public component: O365MailWebComponent;
  public view: O365MailWebView;
  public viewConstructor: typeof O365MailWebView;

  constructor(component: O365MailWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: O365MailWebView,
      viewTemplate: templateO365Mail,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return super.computeEventListeners().concat([
      {
        element: this.view.dom.$applicationId,
        event: 'change',
        callback: this.inputChanged,
      },
      {
        element: this.view.dom.$tenantId,
        event: 'change',
        callback: this.tenantIdChanged,
      },
      {
        element: this.view.dom.$clientSecret,
        event: 'change',
        callback: this.inputChanged,
      },
    ]);
  }

  public inputChanged(ev): void {
    super.inputChanged(ev);
    O365SensorController.reuseO365MailDataIntoAuditFields(ev.currentTarget.id);
  }

  /**
   * TenantId changed event
   * @param ev
   */
  public tenantIdChanged(ev): void {
    // do not dispatch event change or reuse data if we already have same values,
    // otherwise it will go to infinite loop -> maximum call stack size exceeded
    if (O365SensorController.isSameValueIntoFields(O365AuditFields.TENANT, O365MailFields.TENANT)) {
      return;
    }

    super.inputChanged(ev);

    if (O365SensorController.isSensorEnabled(WEB_COMPONENT_SENSOR_O365_AUDIT)) {
      O365SensorController.reuseO365FieldForTenantId(ev.currentTarget.id);
    }
  }

  public toggleEnable(): void {
    super.toggleEnable();

    if (this.isSensorEnabled()) {
      // copy the tenantId from audit to mail.
      O365SensorController.reuseO365Field(O365AuditFields.TENANT, O365MailFields.TENANT);

      // remove disabled for use same details
      O365SensorController.disableO365AuditReuseData(false);
      return;
    }

    // if mail has been disabled -> uncheck && set disable for "Use the same details"
    O365SensorController.disableO365AuditReuseData(true);

    // if mail has been disabled -> remove readonly for O365 audit fields
    O365SensorController.setReadOnlyForO365AuditField(O365AuditFields.TENANT, false);
    O365SensorController.setReadOnlyForO365AuditField(O365AuditFields.APPLICATION, false);
    O365SensorController.setReadOnlyForO365AuditField(O365AuditFields.CLIENT_SECRET, false);
  }

  public postInit(ev): void {
    // if mail (current sensor) is disabled -> disable the reuseData
    if (!this.isSensorEnabled()) {
      O365SensorController.disableO365AuditReuseData(true);
    }
  }
}
